import loopboxLogoDark from "assets/images/loopblack.png";
import loopboxLogoLight from "assets/images/loopwhite.png";

export const BRAND_NAME = "LOOPBOX";

export const BRAND_COLORS = {
  bg: "#eef2f6",
  sidebarStart: "#07172b",
  sidebarEnd: "#0c2542",
  text: "#13263a",
  mutedText: "#5f7286",
  primary: "#077be2",
  primaryDark: "#0466c2",
  primarySoft: "#d8ebff",
  success: "#56c05f",
  warning: "#f0b14a",
  danger: "#ef5b56",
};

export const BRAND_LOGOS = {
  dark: loopboxLogoDark,
  light: loopboxLogoLight,
};
